import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Transport} from '../../model/Entities/Transport';

@Component({
    selector: 'transport-delete-confirm-dialog',
    templateUrl: './transport-delete-confirm.dialog.component.html',
    styleUrls: ['./transport-delete-confirm.dialog.component.scss']
})
export class TransportDeleteConfirmDialogComponent {

    transport: Transport;

    constructor(public dialog: MatDialogRef<TransportDeleteConfirmDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.transport = data.transport;
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/TransportDeleteConfirmDialogComponent/transport-delete-confirm.dialog.component.ts